const o = (e, r) => {
  let t = !1;
  return (...l) => {
    t || (e(...l), t = !0, setTimeout(() => t = !1, r));
  };
};
export {
  o as throttle
};
